import { type ElementStyles, css } from '@microsoft/fast-element';
import type { HoverIconDefinition, HoverIcon } from './HoverIcon';
import { deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import { deleteRow } from 'owa-mail-list-item-shared';
import { DeleteFilled, DeleteRegular } from '@fluentui/react-icons/fonts';

const DeleteRegularFontGlyph = DeleteRegular.codepoint;
const DeleteFilledFontGlyph = DeleteFilled.codepoint;

const BaseDeleteIconStyles: ElementStyles = css`
    .icon:before {
        color: var(--colorNeutralForeground3);
        content: '${DeleteRegularFontGlyph}';
    }

    :host(:hover) .icon:before,
    :host(:active) .icon:before {
        color: var(--colorStatusDangerForeground1);
        content: '${DeleteFilledFontGlyph}';
    }
`;

export const Delete: HoverIconDefinition = {
    title(this: Readonly<HoverIcon>) {
        return deleteItem;
    },
    customCss: BaseDeleteIconStyles,
    onClick(this: HoverIcon) {
        deleteRow(this.rowKey, this.tableViewId, 'Hover');
    },
};
